<template>
  <div class="d-flex flex-column align-center pt-15">
    <div class="text-h5 primary--text text--darken-1 font-weight-bold text-center text-wrap">{{ stylist.staff_name }}</div>
    <div class="box mt-10 mb-6">
      <img
        class="stylist-image"
        :class="{ 'default-stylist-image': !stylist.staff_photo }"
        :src="stylist.staff_photo ? stylist.staff_photo : '/icons/profile_icon.svg'"
        :width="stylist.staff_photo ? '200px' : '140px'"
        :height="stylist.staff_photo ? '200px' : '140px'"
      />
    </div>
    <v-container class="px-10 my-10">
      <v-row>
        <v-col md="4" offset-md="3" class="pb-0 font-weight-medium">
          <div>1. {{ $t('label.friendliness') }}</div>
          <v-rating v-model="ratings[ToReview.reviewType.FRIENDLINESS]" background-color="primary lighten-3" color="primary" half-increments length="5" size="36" hover dense></v-rating>
        </v-col>
        <v-col md="4" class="pb-0 font-weight-medium">
          <div>2. {{ $t('label.skillfullness') }}</div>
          <v-rating v-model="ratings[ToReview.reviewType.SKILLFULLNESS]" background-color="primary lighten-3" color="primary" half-increments length="5" size="36" hover dense></v-rating>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="4" offset-md="3" class="pb-0 font-weight-medium">
          <div>3. {{ $t('label.responsiveness') }}</div>
          <v-rating v-model="ratings[ToReview.reviewType.RESPONSIVENESS]" background-color="primary lighten-3" color="primary" half-increments length="5" size="36" hover dense></v-rating>
        </v-col>
        <v-col md="4" class="pb-0 font-weight-medium">
          <div>4. {{ $t('label.personalImage') }}</div>
          <v-rating v-model="ratings[ToReview.reviewType.PERSONAL_IMAGE]" background-color="primary lighten-3" color="primary" half-increments length="5" size="36" hover dense></v-rating>
        </v-col>
      </v-row>
      <v-textarea v-model="comment" :placeholder="$t('placeholder.typeHere')" counter="250"></v-textarea>
    </v-container>

    <v-card-actions class="mb-8">
      <v-btn outlined color="primary darken-1" class="mr-15 px-12 rounded-pill text-capitalize align-self-center" @click="next">
        {{ $t('button.skip') }}
      </v-btn>
      <v-btn color="primary" class="px-12 rounded-pill green-gradient-right text-capitalize align-self-center" @click="submitReview">
        {{ submit ? $t('button.submit') : $t('button.next') }}
      </v-btn>
    </v-card-actions>
    <app-dialog v-model="dialogIsOpen" title="" maxWidth="400">
      <div class="text-body-1 font-weight-medium my-5">{{ $t('message.rateToProceed') }}</div>
      <app-button class="green-gradient-right override-disabled-styles px-15 mt-5" type="submit" invert gradient :label="$t('button.okay')" @click="dialogIsOpen = false" />
    </app-dialog>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { ToReview } from '@/constants/enums'
export default {
  props: {
    stylist: { required: true },
    submit: { required: true }
  },
  data() {
    return {
      ToReview,
      reviewForm: {
        reviews: [],
        comments: []
      },
      ratings: {},
      comment: null,
      dialogIsOpen: false
    }
  },
  methods: {
    ...mapMutations('review', ['setSalonStylistReviewForm']),
    next() {
      this.reviewForm.reviews = []
      this.reviewForm.comments = []
      this.ratings = {}
      this.comment = null

      this.submit ? this.$emit('submit') : this.$emit('stepUp')
    },
    submitReview() {
      if (Object.keys(this.ratings).length < 4) {
        this.dialogIsOpen = true
        return
      }
      for (let reviewType of Object.keys(this.ratings)) {
        this.reviewForm.reviews.push({
          type: ToReview.type.STYLIST,
          item_id: this.stylist.staff_id,
          review_type: reviewType,
          rating: this.ratings[reviewType]
        })
      }
      if (this.comment) {
        this.reviewForm.comments.push({
          type: ToReview.type.STYLIST,
          item_id: this.stylist.staff_id,
          rating: 0,
          comment: this.comment
        })
      }

      this.setSalonStylistReviewForm(this.reviewForm)
      this.next()
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  width: 180px;
  height: 180px;
  border-radius: 99vw;
  border: 1px solid #808080;
}
.stylist-image {
  border-radius: 50%;
  object-fit: cover;
}
.default-stylist-image {
  display: block;
  object-fit: contain;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0;
  padding-top: 30px;
}
</style>
